import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight, Plus } from "lucide-react";
import { categories6 } from "@/data/categories6";

export default function ServiceAccordion({ defaultOpen = null }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-t rule-dark" data-testid="services-accordion">
      {categories6.map((c) => {
        const isOpen = open === c.id;
        return (
          <div key={c.id} className="border-b rule-dark" data-testid={`service-category-${c.id}`}>
            <button
              onClick={() => setOpen(isOpen ? null : c.id)}
              className="w-full flex items-center gap-5 sm:gap-8 py-7 sm:py-8 text-left group"
              aria-expanded={isOpen}
              data-testid={`service-toggle-${c.id}`}
            >
              <span className="font-mono text-[12px] text-gold w-8 shrink-0">{c.num}</span>
              <span
                className={`flex-1 h-display font-bold text-[22px] sm:text-3xl lg:text-4xl leading-tight transition-colors duration-300 ${
                  isOpen ? "text-gold" : "text-white group-hover:text-gold"
                }`}
              >
                {c.name}
              </span>
              <span
                className={`w-10 h-10 shrink-0 rounded-full border flex items-center justify-center transition-all duration-300 ${
                  isOpen ? "border-gold text-gold rotate-45" : "border-white/25 text-mute group-hover:border-gold group-hover:text-gold"
                }`}
              >
                <Plus size={17} />
              </span>
            </button>

            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                  className="overflow-hidden"
                  data-testid={`service-panel-${c.id}`}
                >
                  <div className="pb-10 pl-8 sm:pl-16 max-w-3xl">
                    <p className="text-mute text-[15px] leading-relaxed mb-7">{c.summary}</p>
                    <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-2.5 mb-9">
                      {c.services.map((s) => (
                        <li key={s.label} className="flex items-start gap-3 text-[14px] text-white/85">
                          <span className="w-1 h-1 rounded-full bg-gold mt-2 shrink-0" />
                          {s.slug ? (
                            <Link to={`/services/${s.slug}`} className="hover:text-gold transition-colors" data-testid={`service-item-${s.slug}`}>
                              {s.label}
                            </Link>
                          ) : (
                            s.label
                          )}
                        </li>
                      ))}
                    </ul>
                    <Link to={`/contact?service=${encodeURIComponent(c.ctaService)}`} className="btn-outline-gold" data-testid={`service-cta-${c.id}`}>
                      {c.cta} <ArrowUpRight size={15} />
                    </Link>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
